import { createAction } from '@reduxjs/toolkit';
import { normalizeError } from 'core/common/errors';
import { AppThunk } from 'core/common/store';
import { addLeadingSlash } from 'core/common/utils/string';
import { Flow } from 'core/flow/entities';
import { Languages } from 'core/localization/entities';
import { FunnelConfig } from '../entities';

export const updateConfig = createAction<FunnelConfig>('funnelConfig/UPDATE');

export const loadFunnelConfigPending = createAction('funnelConfig/LOAD_CONFIG/pending');
export const loadFunnelConfigSucceed = createAction<FunnelConfig | null>(
  'funnelConfig/LOAD_CONFIG/succeed',
);
export const loadFunnelConfigFailed = createAction('funnelConfig/LOAD_CONFIG/failed');
export const updateFlow = createAction<Flow>('funnelConfig/UPDATE_FLOW');

type LoadFunnelConfigParams = {
  funnelId: string;
  language?: Languages;
  flowId?: string;
};

export const loadFunnelConfig =
  ({ funnelId, language, flowId = '' }: LoadFunnelConfigParams): AppThunk =>
  async (dispatch, getState, context) => {
    const { loggingService, funnelService } = context;

    try {
      dispatch(loadFunnelConfigPending());

      const funnels = await funnelService.getFunnels({
        flowName: flowId,
        funnelLink: addLeadingSlash(funnelId),
        language,
      });

      if (!funnels) {
        dispatch(loadFunnelConfigFailed());
        return;
      }

      const currentFunnel = funnels[0];

      dispatch(loadFunnelConfigSucceed(currentFunnel));
    } catch (e) {
      const err = normalizeError(e);
      loggingService.error(err);

      dispatch(loadFunnelConfigFailed());
    }
  };
